module.exports = __webpack_public_path__ + "img/ios_2.3a934350.png";